<router-outlet></router-outlet>

<ngx-ui-loader [hasProgressBar]="false" [fgsType]="spinner.threeStrings" text="Loading..."></ngx-ui-loader>
